import React from 'react';

/**
 * Bloc de chargement (shimmer) — style refonte (tons crème). Purement décoratif :
 * aria-hidden + role status sur le conteneur appelant si besoin.
 */
export const Skeleton: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div aria-hidden className={`animate-pulse bg-raise rounded ${className}`} />
);

/** Grille de cartes fantômes (santé clients, etc.). */
export const SkeletonCards: React.FC<{ count?: number; className?: string }> = ({
  count = 6,
  className = '',
}) => (
  <div
    role="status"
    aria-label="Chargement…"
    className={`grid grid-cols-1 min-[900px]:grid-cols-2 min-[1200px]:grid-cols-3 gap-4 ${className}`}
  >
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-panel border border-line rounded-card p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-3 w-1/2 mt-2" />
          </div>
          <Skeleton className="h-4 w-14" />
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <Skeleton className="h-6" />
          <Skeleton className="h-6" />
        </div>
      </div>
    ))}
  </div>
);

/** Lignes fantômes (listes/registres). */
export const SkeletonRows: React.FC<{ count?: number; className?: string }> = ({
  count = 6,
  className = '',
}) => (
  <div role="status" aria-label="Chargement…" className={`divide-y divide-line ${className}`}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="py-3 flex items-center gap-3">
        <div className="flex-1">
          <Skeleton className="h-3.5 w-1/2" />
          <Skeleton className="h-2.5 w-1/3 mt-2" />
        </div>
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-16" />
      </div>
    ))}
  </div>
);

export default Skeleton;
